const attach = () =>
    import( /* webpackChunkName: "attach" */ '@/page/attach/attach')
const attachList = () =>
    import( /* webpackChunkName: "attach" */ '@/page/attach/list')

const attachRouter = {
    path: 'attach',
    name: 'attach',
    component: attach,
    children: [{
        path: 'all',
        name: 'allAttach',
        component: attachList
    }, {
        path: 'image',
        name: 'imageAttach',
        component: attachList
    }, {
        path: 'doc',
        name: 'docAttach',
        component: attachList
    }, {
        path: 'video',
        name: 'videoAttach',
        component: attachList
    }, {
        path: 'audio',
        name: 'audioAttach',
        component: attachList
    }, {
        path: 'compress',
        name: 'compressAttach',
        component: attachList
    }, {
        path: '/attach*',
        redirect: 'all'
    }]
}

export default attachRouter



// WEBPACK FOOTER //
// ./src/router/attach.js